import { render, staticRenderFns } from "./LiveEventTest.vue?vue&type=template&id=e8b22aa6"
import script from "./LiveEventTest.vue?vue&type=script&lang=js"
export * from "./LiveEventTest.vue?vue&type=script&lang=js"
import style0 from "./LiveEventTest.vue?vue&type=style&index=0&id=e8b22aa6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports